export default __webpack_public_path__ + "static/media/dotnet.211c0be7.svg";